module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Description à venir",
      "id": "fig-004",
      "src": "images/chap1.jpg"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("FAITH IS ON THE RISE")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-005"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Description à venir",
      "src": "images/CH_Dingbat_color.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BREATHED IN HOT, DRY AIR")]), _vm._v(",")]), _vm._v(" walking toward the conference center to the rhythm of a drum and twanging notes from guitars. Two hundred young people were on their feet in worship, in a setting outside Erbil, Iraq, just miles from towns controlled by the genocidal forces of ISIS. Iraqi young people arrived, public in faith, bold in witness, determined to live for Christ regardless of what other forces attempted to dictate.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("With their entire lives ahead of them, why would they choose to clearly identify with Christian faith and immerse themselves in its life and witness? Surely, when faced by religious hostilities and Islamic militants threatening their existence, they would temper their enthusiasm or at least camouflage their identity. This is a picture of the kind of resilient and progressive faith that is playing itself out in communities, countries, and regions around the globe today. Why and how is this happening? This question led to the writing of this book. I simply had to find out for myself.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Weeks earlier, I had driven north from Cairo toward Alexandria, through mile after mile of desert, much of it fenced, marking it as "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("military property. Our driver pulled across the expressway to a sandy road, bumping along for a few kilometers. Taking a sharp turn in the desert, we arrived at the Wadi Conference Center, a 150-acre facility with its own 250-room hotel, soccer field, and sports facilities. The center was host to a conference on missions, attended by more than four hundred Egyptians, whose average age was in the mid-thirties. It was an outreach of the Kasr El Dobara Evangelical Church, which meets just off the (in)famous Tahrir Square in downtown Cairo. The church became well known during the Arab Spring of 2011. As students were gunned down, Pastor Sameh Tawfik, trained as a medical doctor, turned the church into a field hospital.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the conference, I wondered who could imagine that hundreds, mostly young people, would attend a conference on Christian missions in a country overwhelmed by the Arab Spring, and unglued by political wars, religious domination, and social revolution. Rather than hide, defend, or simply maintain its existence, this church in downtown Cairo models risk-taking faith, not only within its national borders, but also through its missional activities into Iraq and throughout the Middle East. If you want to know what is going on among Christians, this is a good place to start. Here in the face of opposition, persecution, and killings, in places where one doesn’t expect vital and active faith, there are bold, exceptional, and unafraid people, “youth-full” with energy—an exuberant faith that is lived not just for themselves but oriented toward making it known to others.")]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-006"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Description à venir",
      "src": "images/sep.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As the refugee crises tore holes in borders, defied governmental policies, disrupted border patrols, and drove frazzled bureaucrats to frenzy, we arrived in Lesbos, the Greek island between the mainland and Turkey."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-002",
      "id": "ap_ntf-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The twin-engine plane banked to the left as "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("we skirted the beach and lined up for the island runway. Suddenly something bright and orange caught my eye. It was a congregation of lifejackets: thousands on thousands, littering the shoreline.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The beach closest to Turkey’s mainland is eleven kilometers away across the open water. Up to ten thousand people a day risked their lives to cross the strait. One family crawled out of a fragile boat holding fifty people. Having bribed and paid their way across Syria, they hid in bushes on Turkey’s western seashore. Smugglers found them and for a thousand euros (minimum) each, the smugglers provided a rubber dinghy powered by a small twenty-five-horsepower outboard motor and life jackets (some were children’s plastic water wings). This family was among the fortunate: they crossed the strait in ninety minutes, as the sea was calm that day, winds modest and temperature 10 degrees Celsius. On other days refugees were caught in storms, confused by direction, lost, struggling for hours to make it to land. According to the Missing Migrant Project, some 3,692 drowned that year."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-003",
      "id": "ap_ntf-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And who was there to greet them, with dry clothes, a hot drink, food, and medical help? I saw primarily Christians from Greece and elsewhere. Most migrating refugees were Muslims, but those who call themselves by Jesus’ name, with nothing but an open heart of welcome and well stocked with provisions, made sure they were greeted and helped along their way. Responses to disaster, I’ve come to learn, are usually served by people of faith, out of something that is part of their spiritual makeup and intuition. When Jesus said, “Love your neighbor as yourself,” he wasn’t suggesting this as a good idea: love is a spiritual force causing us to help instinctively as his followers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-004",
      "id": "ap_ntf-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Go back now to 1990, when there were four or five known Christians in Mongolia. After the Soviet Union lost its grip, windows of faith opened. Freed from Soviet domination, it was a country searching for identity. Mungunkhet, a fifteen-year-old, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("was walking downtown one evening when he saw the"), _c('i', [_vm._v(" Jesus")]), _vm._v(" film being shown on a big screen on the street. He stopped and watched. “At that moment,” he says, “I wanted to get into the story.” His parents had divorced; his father murdered the man who had taken his mother and he was now in jail. In six months, Mungunkhet joined a church in his town begun by other teenagers who had come to faith after seeing the movie. In time he became its pastor.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Today, as head of a television company, Mungunkhet remarks, “In 1200 a Mongolian army of 100,000 conquered much of the world—through sword and fear. Today with 45,000 Christians, in his power and love, we can reach our world, for love is more powerful than fear.”")]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-007"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 1. The movement of the center of world Christianity",
      "src": "images/figure_1_color.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('b', [_vm._v("Figure 1.")]), _vm._v(" The movement of the center of world Christianity")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Two thousand years ago the Christian church began on the day of Pentecost in the city of Jerusalem. Since then the demographic "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("“center” of Christian populations has made its way across Europe."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-005",
      "id": "ap_ntf-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" With the surprising growth of the Christian community globally in the past fifty years, the demographic weight of Christianity in Africa and Asia has pulled this global center south and west. Demographers now place the center of population density of Christians in Africa (see "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#fig-007"
    }
  }, [_vm._v("figure 1")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The metaphorical center of world Christianity has literally moved from Jerusalem to Timbuktu in the nation of Mali. This is not merely some clever title—it is a remarkable sign that points out what we otherwise might miss. Long a city name used as a metaphor for a far-away and unreachable place, today Timbuktu signifies this massive shift, as the location of the center represents a mighty upsurge in Christian faith around the shrinking globe.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What is the extent of that growth? The answer might come as something of a surprise, particularly to those in the West. Even those least inclined to dismiss religion from ideological modernist presumptions—the Lutheran sociologist Peter Berger, for example—during the 1960s fell into the trap of assuming that the trends in former state-church Western European nations (such as France and Sweden) were part and parcel of modernization. In 1968, Berger projected that by “the twenty-first century, religious believers are likely to be found only in small sects, huddled together to resist a worldwide secular culture”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-006",
      "id": "ap_ntf-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" typified by the fragmentation of life and the division of labor. Thirty years later, however, these projections seemed far less plausible. As Peter Berger now notes, “The assumption that we live in a secularized world is false. The world today . . . is as furiously religious as it ever was, and in some places more so than ever. This means that a whole body of literature by historians and social scientists loosely labeled ‘secularization theory’ is essentially mistaken"), _c('i', [_vm._v(".")]), _vm._v("”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-007",
      "id": "ap_ntf-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The journey from Jerusalem to Timbuktu, with its relocation of the Christian center out of its centuries-long European habitat, alerts "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("us that much is going on. As we will see, this growth and relocation is not driven merely by external forces, but also by reexpressions of faith in five major ways. It is those reasons, or"), _c('i', [_vm._v(" drivers,")]), _vm._v(" that we will explore in this book. Some expand the witness of the gospel, resulting in remarkable growth of churches and the Christian population. Others do more in reshaping the vision and heart of the gospel, its self-understanding and ways of seeing its surrounding world.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("SECULAR ASSUMPTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("An analogy (of sorts) takes me back more than a few years, to my university days.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The small graduate class in Montreal met in our professor’s home; it was the late 1960s. As he outlined why faith as a working framework for life was reaching its end, I heard background music coming from the kitchen—so I asked if we could listen. It was Judy Collins singing “Amazing Grace,” the longest-playing number-one song on the music charts, ever. The incongruity was striking. While the academy allowed that faith might have a sort of personal value, or even have a “cohering” or binding effect for people in need, the idea that it might become an overarching story, a"), _c('i', [_vm._v(" meta")]), _vm._v(" narrative or a basis for an ethics of civic life, was dismissed out of hand. Religion in the postmodern age was merely a matter of aesthetics.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Science, it was assumed, would displace faith as a way to understand humanity, history would discredit religion’s explanations, democracy would give citizens power to overturn religion, and global industrialization would fix human dilemmas of poverty and sickness. In summary, secularism worked from the premise that “religion’s regress spelled humanity’s progress.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-008",
      "id": "ap_ntf-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Secularism would drive out its predecessors from the “dark ages” of religious belief.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What is the basis for this conjecture? The “hard secularization” thesis claims that, as societies become increasingly scientific, both interest and need for religious faith will be replaced by "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("self-confidence, leaving little need for a God (at least insofar as to how one actually lives)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-009",
      "id": "ap_ntf-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" After all, if we can put an astronaut on the moon, what need is there to rely on a Creator Being? If we can multitransplant organs, what need have we of a Healer Being? If we can bring about psychological healing, what need is there of a Therapist Being? If social engineering can elevate the poor, what need is there of a Supplier Being? “No need,” at all, seemed to be the received wisdom of the West.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Despite such declarations, faith in the Majority World is on the rise. Even as public policy and the dominant elites in the West act as though faith is on the losing side, Western public interventions abroad are constantly confronted with surging faith. This is true not only in secluded worlds of congregations, mosques, or temples, but in the wider spheres of human activity—politics, business, sports, media, arts, and science.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Even for that small group of university students in Montreal in 1969, our"), _c('i', [_vm._v(" experience")]), _vm._v(" was different from what we heard in the academic bubble. Even as secularists posited their predictions—in the late 1960s and early 1970s—a grassroots Christian faith was turning the secular assumption on its head among (of all people) countercultural hippies."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-010",
      "id": "ap_ntf-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" It was a movement of escapism. Ironically, as it turned out, the religious response of long-haired Christian humanitarians was much more closely aligned with what was really happening in the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-011",
      "id": "ap_ntf-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A SURPRISING SURGE")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even as that secularist current moved its way through our world, another stream was gathering strength. There is an unstoppable tide rising in most regions outside the West."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-012",
      "id": "ap_ntf-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Africa.")])]), _vm._v(" The 1910 World Missionary Conference in Edinburgh predicted that by the end of the century, Africa would be Islamic. It hasn’t happened. Within my lifetime, the Christianization of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("much of Africa would have amazed even David Livingston. In 1900 Africa was home to 8.7 million Christians. Today there are 542 million, with estimates that by 2050 this will rise to 1.2 billion. While Africa makes up 14.9 percent of the global population, it holds 21.9 percent of the world’s Christians."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-013",
      "id": "ap_ntf-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" In 1970, 38.7 percent of Africa was Christian (mostly in sub-Saharan Africa); by 2020 that will rise to 49.3 percent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-014",
      "id": "ap_ntf-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This continent is sharply divided. A dominant Islamic presence in the north—Egypt, Somalia, Libya, Algeria, Tunisia, Sudan, and Morocco—has been joined by the gradual but determined Islamic move below the Sahara. But sub-Saharan Africa now is mostly Christian. The historic presence of mission work has built a core of Christian churches, and the many educational and medical initiatives have created a bulwark of witness, beyond which a vast indigenization of the faith has taken place.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Asia")])]), _vm._v(". When the Kuomintang government fell to Mao Tse-tung and his forces in 1949, there were under a million Christians in China. Through the Cultural Revolution, Christians were not only “reeducated,” but many were also killed. Today the exploding population of Chinese Christians is estimated to number 100 million or more. “If the growth continues at the rate of 7 percent, Christians could be 32.5 percent of the Chinese population by 2040 and 66.7 percent by 2050.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-015",
      "id": "ap_ntf-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Best known in Asia (and symbolic of church growth in the Majority World) is the Yoido Full Gospel Church in Seoul, South Korea. Located near the government’s national assembly building, its large and unassuming campus is home to just under a million members;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-016",
      "id": "ap_ntf-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" estimates are that 5 percent of the city attends this church. While its sanctuary seats only twelve thousand, its many auditoriums seat another twenty thousand, and multiple services over the weekend provide for its attendees, including a Sunday school of thirty-eight thousand. This city is thus the home to the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("largest Pentecostal (and Presbyterian, and Methodist) churches in the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In 1960, there were thirty known Christians in Nepal; today, there are more than 1.4 million."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-017",
      "id": "ap_ntf-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Isolated from other cultures, the country did not allow most foreign missions. Then, some time after 1960, conversions began to multiply, seemingly without strategy or forethought. One link was Britain’s traditional recruitment of Nepalese Ghurkas to fight in the British army. Enlisted, many serving abroad heard of the gospel and came to faith. Returning to their families and villages, they told about the Jesus they had met. Soon churches flourished. Another link lay in the relative lack of university training in the country. Most students went elsewhere, where they contacted Christians in the countries of study. After graduating they, too, returned home and, as with the returning soldiers, told their families and friends about Christ. Churches thus began to spring up in this remote country as a result of the remigration of Christianity through these global wanderers.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Latin America.")])]), _vm._v(" Viewed as the most Christianized continent on earth, the spiritual transformation of Latin America has become a bellwether for Christian witness globally. Roman Catholics arrived with their European masters, forming a religious monopoly that made every effort to prevent Protestants from relocating there. In the twentieth century, however, as the movement of Spirit-empowered ministries circled the globe, Latin American countries felt that same presence.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("By mid-century, the Catholic Church in Latin America was in serious decline. So few males were entering the priesthood that most were brought in from abroad. Only 20 percent of its citizens were active participants."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-018",
      "id": "ap_ntf-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Protestant mission, especially by Pentecostals, resulted not only in rapid Evangelical/Pentecostal increase, but also in Catholic revitalization. Drawing from the Gallup World Poll, Rodney Stark notes that in four of eighteen countries, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("Protestants make up a third of the population, and in eight others, over 20 percent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-019",
      "id": "ap_ntf-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" The Pentecostal and Charismatic renewal movements triggered within Catholics a remarkable shift in emphasis in worship forms and community address. The gospel message, with its fire and zeal, is capturing the Latin heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("North America.")])]), _vm._v(" A recent United States survey triggered headlines that faith is declining: the Boomer generation is being replaced by Millennials, who are less and less interested in church. Such statistics obviously have a political orientation, where the word"), _c('i', [_vm._v(" Evangelical")]), _vm._v(", or even"), _c('i', [_vm._v(" Christian")]), _vm._v(", is often reduced to a demographic or voting description rather than a faith position. Some read this as “the sky is falling in,” but Ed Stetzer disagrees: “Christianity and the church are not dying, but they are being more clearly defined.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Over seven years (2007–2014), Pew learned that those who self-identify as Christian dropped from 78 to 70 percent. The percentage of Roman Catholics moved from 23 to 20 percent, mainline Protestants from 18 to 14 percent, and those declaring they have no religious affiliation from 16 to 21 percent. Evangelicals dipped 1 percent from 26 to 25 percent but added in adult numbers by about five million."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-021",
      "id": "ap_ntf-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Gallup found"), _c('i', [_vm._v(" actual")]), _vm._v(" weekly religious attendance was about the same as in the 1940s. While those saying they had no religious affiliation grew from 16 to 21 percent in seven years, as Ed Stetzer notes, “Many of these who have been labeling themselves as Christians are starting to feel free to be honest about their religious affiliation, or lack thereof.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-022",
      "id": "ap_ntf-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("New York City pastor Tim Keller of Redeemer Church assesses—in a concerted move to provide places and train people for the gospel story—that today some 5 percent attend a church that has a “high view” of Scripture, up fivefold from 1 percent a couple of decades ago. He champions a strategy to raise that to 15 percent in a decade."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("What is surprising is that 50 percent of Christians in the United States continue to self-identify as Evangelical, with over half attending church weekly. And that number has gone up, not down: in the Gallup poll taken immediately before the time of writing, weekly church attenders were seen to rise from 34 to 35 percent. Millennials continue to constitute 21 percent of the Evangelical world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In decades of serving leadership in the Christian community, I have never seen such communities of spiritual renewal, social concern, and worship as I am seeing today. There is something afoot, both in the land of my birth and in the wider global community.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A country rooted in a Christian heritage—even when that faith has become dormant for too many years—has within it the residual possibilities of renewal and transformation. As each generation takes hold of Christ, and as each of us rises in the morning with the conscious responsibility to immerse ourselves in biblical faith, the Spirit is present, and more than willing, to infuse his people, and by them their society, with a renewed grasp of the truth and life of the risen Lord. The rumor that God had “died” is being discredited, as “the last four decades have shown religious belief also to be a destroyer of dictatorships, an architect of democracy, a facilitator of peace negotiations and reconciliation initiatives, a promoter of economic development and entrepreneurship, a partisan in the cause of women, a warrior against disease and a defender of human rights.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("THE DRIVERS OF GLOBAL FAITH")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the coming five chapters we will explore the drivers giving energy to this rise of faith among people who expect God to break in on his creation. I have experienced these drivers personally from years of service in national and international agencies. Recently, I led a team to publish the first-of-its-kind"), _c('i', [_vm._v(" Evangelicals Around the World: A Global Handbook for the 21st Century.")]), _vm._v(" This examination of our global Christian community gave additional insights into our "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("history and practice of our faith. Visiting with missiologists and speaking with scholars, leaders on the front lines, and agencies immersed in the tough issues of bringing life into dark places have taught me to see our landscape more clearly.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the forefront of this amazing growth is a church that has come to know and appreciate the person and gifts of the Holy Spirit. In societies overborne by poverty, empty political promises, and inner vacancy, within emerging generations there is a search for spiritual wholeness and societal peace. The rise of Christian witness is enabled by a new and revitalized encounter and infilling of the Spirit. Even though Christians are trinitarian in theology, functionally we have operated on a dual pivot: the Father and the Son. This repositioning of our theology and spiritual practice to a more faithful trinitarian vision is the basis of what we are witnessing today."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" This is the first driver.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Underlying everything that Christians are and do is our Bible—the second driver. In the early 1500s, the Reformation charged forth in both Germany and England as the Bible was translated into the language of people on the street, giving those who could read the opportunity to engage the text for themselves. William Tyndale, the first to translate the Bible into recognizably modern English from the original languages, said that he did this work so “a ploughboy” could read it. Luther in Germany and Tyndale in England unleashed the power of the Word, enabled by the Spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I was born with a Bible, in my language, in my hand. It has always been with me, without my ever knowing anything different. For people who have never read the Bible in their own language, a translation sensitive to their culture has an echo effect, resonating immediately with the images and concepts in their minds, rather than having to go through the mediation of a translator. The centuries of Bible translation, however, built a foundation on which the current rapid and stunning building of Christian faith rests.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("The third driver of this tide-like move is the revolutionary influence of locally grown leaders and ideas. This is not unconnected to the first and second drivers—movements of the Spirit are profoundly indigenizing, as is the power of the written word in one’s own language. Great events such as the East Africa Revival, the Harrist movement in West Africa, the Galiwink’u Revival in Australia, and the Pyongyang Revival of 1907 transformed Christianity into a local faith. In each of these, indigenous men and women moved from relying on Western-dominant personnel, methods, forms, and language to those of their own people. As nationals took over, the church changed, sending some mission boards into fits, but these nationals cultivated on their own soil societies receptive to the seed of the authentic and biblical gospel. Indigenous leadership has been critical not only for the astounding growth of the church but also for the church being able to read the gospel in context—that is, in a local language or dialect (vernacular) that expresses what indigenous Christians believe. As missionary Jonathan Goforth noted of the Pyongyang Revival, “Korea made me feel, as it did many others, that this was God’s plan for setting the world aflame.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Indigenization is one of the gospel’s most important strategies for expanding the global church.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Re-engaging the public square—the fourth driver—is, for many, one of the most surprising. Taught for decades, yes for a century, that the gospel was about inner change and eternal redemption, the Evangelical church, both in its sending and receiving, left to others—often secularists, mainline Protestants, and Roman Catholics—the running of government and public service. The shift of Christianity from a privatized spirituality to a wider and more engaged stance is profoundly upsetting for the traditional elites. On the other hand, it also projects into the public imagination of many cultures the shape and role of a new, vibrant, and Christ-centered faith.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("“Wholeness”—the fifth driver—is not a new application of the Bible. When I was a child, helping those in need in our community or raising money for those half a world away was embedded in what our church believed and did. Yet, not unlike the withdrawal from the public square, Evangelicals viewed our calling to be one of personal conversion and salvation for eternal life.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Inevitably agencies and societies sprang up, funded by our communities, who helped us see the human person holistically, not just as a “soul” separated from human needs. This more vigorous integration of the whole person—personal transformation, work, education, food, and family—is based on the understanding that the gospel speaks into all of life. This recognizes how injustices are often the fruit of systemic malignancies in the social body. Taking an axe to these roots is a biblical call. In the end, if God says he loves justice, we should too.")]), _vm._v(" "), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-008"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Description à venir",
      "src": "images/sep.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As younger Christians move in and the older move on, change is an essential part of bringing renewal to the life of the church, its witness, and its vision. This new global church is"), _c('i', [_vm._v(" young")]), _vm._v(". At the mission conference outside of Cairo noted above, I estimated the average age was around thirty-five to forty. In that least probable of places, young men and women, university students, professionals, parents, and their children were intent on learning and then going out into an insecure world with the belief that what they had mattered more than anything else in life.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For two thousand years, the rise and fall of Christian faith has had much to do with renewal and revival. Stagnation is often followed by a break-in of the Spirit, refreshing the ever-new message of the risen Christ: “God has no grandchildren.” Each generation must make its choice. And as demographers observe, one generation can say no to faith and the next yes.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 72
// module chunks = 0